"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractSchemas = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var events_1 = require("events");
var PromiEvent_1 = __importDefault(require("../utils/PromiEvent"));
var constants_1 = require("../utils/constants");
var index_1 = require("../schemas/index");
var tokens_1 = require("../tokens");
var config_1 = require("../config");
var ContractSchemas = /** @class */ (function (_super) {
    __extends(ContractSchemas, _super);
    function ContractSchemas(web3, apiConfig) {
        var _this = _super.call(this) || this;
        _this.TRX = {
            name: 'tron',
            symbol: 'TRX',
            address: constants_1.NULL_ADDRESS,
            decimals: 6
        };
        var networkName = apiConfig.networkName;
        // @ts-ignore
        _this.paymentTokenList = tokens_1.tokens[networkName].otherTokens;
        _this.networkName = networkName;
        _this.chainId = config_1.CHAIN_ID[networkName];
        var contracts = config_1.CONTRACTS_ADDRESSES[networkName];
        var exchangeHelperAddr = contracts.ExchangeHelper;
        var exchangeAddr = contracts.APENFTExchange;
        var APENFTSharedAssetAddr = contracts.APENFTSharedAsset;
        var APENFTExchangeKeeperAddr = contracts.APENFTExchangeKeeper;
        var feeRecipientAddress = contracts.FeeRecipientAddress;
        var erc20AssetProxyAddr = contracts.ERC20AssetProxy;
        var erc721AssetProxyAddr = contracts.ERC721AssetProxy;
        var erc1155AssetProxyAddr = contracts.ERC1155AssetProxy;
        var wtrxAddr = contracts.WTRX;
        _this.contractsAddr = contracts;
        _this.WTRXAddr = wtrxAddr;
        _this.WTRXToken = {
            name: 'tron',
            symbol: 'WTRX',
            address: wtrxAddr,
            decimals: 18
        };
        _this.APENFTSharedAssetAddr = APENFTSharedAssetAddr;
        _this.APENFTExchangeKeeperAddr = APENFTExchangeKeeperAddr;
        _this.feeRecipientAddress = feeRecipientAddress;
        if (exchangeHelperAddr && exchangeAddr) {
            _this.web3 = web3;
            _this.APENFTExchange = exchangeAddr;
            _this.erc20AssetProxy = erc20AssetProxyAddr;
            _this.erc721AssetProxy = erc721AssetProxyAddr;
            _this.erc1155AssetProxy = erc1155AssetProxyAddr;
            _this.Erc20Func = index_1.common.ERC20Schema.functions;
            _this.APENFTRegistryFunc = index_1.common.APENFTRegistrySchemas.functions;
            _this.APENFTExchangeFunc = index_1.common.APENFTExchangeSchemas.functions;
        }
        else {
            throw new Error("".concat(_this.networkName, "  abi undefined"));
        }
        return _this;
    }
    ContractSchemas.prototype.getGasPrice = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, 0
                    /* let gasPrice = 0
                    if (this.networkName == Network.Main) {
                      const response: any = await fetch(GasPrice_NOW.url)
                      const res = await response.json()
                      if (res.code === 200) gasPrice = res.data[GasPrice_NOW.type]
                    } else {
                      gasPrice = Number(await this.web3.eth.getGasPrice())
                    }
                    return gasPrice */
                ];
            });
        });
    };
    ContractSchemas.prototype.tronCall = function (transactionConfig, outputs) {
        return __awaiter(this, void 0, void 0, function () {
            var contractAddress, encodedCallData, rawData, functionSelector, parameters, options;
            var _this = this;
            return __generator(this, function (_a) {
                contractAddress = transactionConfig.to, encodedCallData = transactionConfig.data, rawData = transactionConfig.rawData;
                functionSelector = rawData.functionSelector;
                parameters = rawData.parameters;
                options = {
                    from: this.web3.defaultAddress.hex,
                    callValue: 0,
                    _isConstant: true,
                    feeLimit: 1000000000
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var tradePromise = _this.web3.transactionBuilder.triggerSmartContract(contractAddress, functionSelector, options, parameters, options.from ? _this.web3.address.toHex(options.from) : false);
                        tradePromise
                            .then(function (transaction) {
                            if (!_this.web3.utils.hasProperty(transaction, 'constant_result'))
                                reject('Failed to execute');
                            var len = transaction.constant_result[0].length;
                            if (len === 0 || len % 64 === 8) {
                                var errMsg = 'The call has been reverted or has thrown an error.';
                                if (len !== 0) {
                                    errMsg += ' Error message: ';
                                    var msg2 = '';
                                    var chunk = transaction.constant_result[0].substring(8);
                                    for (var i = 0; i < len - 8; i += 64) {
                                        msg2 += _this.web3.toUtf8(chunk.substring(i, i + 64));
                                    }
                                    errMsg += msg2
                                        .replace(/(\u0000|\u000b|\f)+/g, ' ')
                                        .replace(/ +/g, ' ')
                                        .replace(/\s+$/g, '');
                                }
                                reject(errMsg);
                            }
                            var output = _this.web3.utils.abi.decodeParamsV2ByABI({ outputs: outputs }, '0x' + transaction.constant_result[0]);
                            if (output.length === 1) {
                                output = output[0];
                                if (typeof output === 'object' && !!output && !!output._isBigNumber) {
                                    try {
                                        output = new bignumber_js_1.default(output.toString());
                                    }
                                    catch (err) {
                                        console.log('failed while converting output to BigNumber', err);
                                    }
                                }
                            }
                            resolve(output);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    })];
            });
        });
    };
    ContractSchemas.prototype.tronSend = function (transactionConfig, from) {
        return __awaiter(this, void 0, void 0, function () {
            var contractAddress, encodedCallData, value, rawData, functionSelector, parameters, options, defer, tradeobj, signedTransaction, broadcast, err, checkResult;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        contractAddress = transactionConfig.to, encodedCallData = transactionConfig.data, value = transactionConfig.value, rawData = transactionConfig.rawData;
                        functionSelector = rawData.functionSelector;
                        parameters = rawData.parameters;
                        options = {
                            from: this.web3.defaultAddress.base58,
                            callValue: value || 0,
                            shouldPollResponse: true // Only used for sign()
                        };
                        defer = (0, PromiEvent_1.default)();
                        return [4 /*yield*/, this.web3.transactionBuilder.triggerSmartContract(contractAddress, functionSelector, options, parameters)];
                    case 1:
                        tradeobj = _a.sent();
                        return [4 /*yield*/, this.web3.trx.sign(tradeobj.transaction)];
                    case 2:
                        signedTransaction = _a.sent();
                        if (!signedTransaction.signature) {
                            return [2 /*return*/, Promise.reject('Transaction was not signed properly')];
                        }
                        return [4 /*yield*/, this.web3.trx.sendRawTransaction(signedTransaction)];
                    case 3:
                        broadcast = _a.sent();
                        if (broadcast.code) {
                            err = {
                                error: broadcast.code,
                                message: broadcast.code
                            };
                            if (broadcast.message)
                                err.message = this.web3.toUtf8(broadcast.message);
                            defer.reject(err);
                        }
                        if (!options.shouldPollResponse) {
                            defer.resolve(signedTransaction.txID);
                            defer.eventEmitter.emit('transactionHash', signedTransaction.txID);
                            return [2 /*return*/, Promise.resolve({ txHash: signedTransaction.txID, txSend: defer.eventEmitter })];
                        }
                        checkResult = function (index) {
                            if (index === void 0) { index = 0; }
                            return __awaiter(_this, void 0, void 0, function () {
                                var output, latestBlock, latestBlockNumber, txBlockNumber, confirmationNumber;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (index === 30) {
                                                return [2 /*return*/, defer.reject({
                                                        error: 'Cannot find result in solidity node',
                                                        transaction: signedTransaction
                                                    })];
                                            }
                                            return [4 /*yield*/, this.web3.trx.getUnconfirmedTransactionInfo(signedTransaction.txID)];
                                        case 1:
                                            output = _a.sent();
                                            if (!Object.keys(output).length) {
                                                return [2 /*return*/, setTimeout(function () {
                                                        checkResult(index + 1);
                                                    }, 2000)];
                                            }
                                            if (output.receipt) {
                                                defer.eventEmitter.emit('receipt', { transaction: signedTransaction, output: output });
                                            }
                                            if (output.result && output.result === 'FAILED') {
                                                return [2 /*return*/, defer.reject({
                                                        error: this.web3.toUtf8(output.resMessage),
                                                        transaction: signedTransaction,
                                                        output: output
                                                    })];
                                            }
                                            if (output.receipt && output.receipt.result !== 'SUCCESS') {
                                                return [2 /*return*/, defer.reject({
                                                        error: this.web3.toUtf8(output.resMessage),
                                                        transaction: signedTransaction,
                                                        output: output
                                                    })];
                                            }
                                            if (!('contractResult' in output)) {
                                                return [2 /*return*/, defer.reject({
                                                        error: 'Failed to execute: ' + JSON.stringify(output, null, 2),
                                                        transaction: signedTransaction,
                                                        output: output
                                                    })];
                                            }
                                            return [4 /*yield*/, this.web3.trx.getBlock('latest')];
                                        case 2:
                                            latestBlock = _a.sent();
                                            latestBlockNumber = latestBlock.block_header.raw_data.number;
                                            txBlockNumber = output.blockNumber;
                                            confirmationNumber = latestBlockNumber - txBlockNumber;
                                            // if(output.receipt && output.receipt.result === 'SUCCESS'){
                                            if (confirmationNumber > 4) {
                                                defer.eventEmitter.emit('confirmation', confirmationNumber, output, signedTransaction);
                                                if ('contract_address' in output) {
                                                    output['contract_address'] = this.web3.address.fromHex(output['contract_address']);
                                                    return [2 /*return*/, defer.resolve(output)];
                                                }
                                            }
                                            defer.eventEmitter.emit('confirming', confirmationNumber, output, signedTransaction);
                                            setTimeout(function () {
                                                checkResult(index + 1);
                                            }, 2000);
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        };
                        checkResult();
                        return [2 /*return*/, Promise.resolve({ txHash: signedTransaction.txID, txSend: defer.eventEmitter })];
                }
            });
        });
    };
    return ContractSchemas;
}(events_1.EventEmitter));
exports.ContractSchemas = ContractSchemas;
